/// <reference types="@angular/localize" />

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { ToastrModule } from 'ngx-toastr';
import { routes } from './app/app-routing.module';
import { AppComponent } from './app/app.component';
import { initializeSentry, provideSentry } from './app/providers/sentry.provider';
import { authInterceptor } from './app/services/auth.interceptor';

initializeSentry();

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimations(),
    importProvidersFrom(
      ToastrModule.forRoot({
        positionClass: "toast-bottom-right",
        timeOut: 10000
      })
    ),
	...provideSentry()
  ]
}).catch(err => console.error(err));
